import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "@charphq/ui/providers/auth-provider";
import { ApiKeysPageContainer } from "@charphq/ui/components/api-keys/api-keys-page-container";
import { requireAuth } from "../lib/auth-guards";
import { navOrganizationsQuery, roleCanManageOrg } from "../lib/organizations";

export const Route = createFileRoute("/api-keys")({
  beforeLoad: async () => {
    // Any authenticated user may open the page; it self-gates management to the ACTIVE
    // organization's owner/admin (or a super admin), and the backend re-enforces apiKey:*.
    await requireAuth();
  },
  component: ApiKeysPageComponent,
});

function ApiKeysPageComponent() {
  const { isAuthenticated, user, session } = useAuthContext();
  const activeOrgId = (session as { activeOrganizationId?: string } | null)?.activeOrganizationId;
  const isSuperAdmin = (user as { isSuperAdmin?: boolean } | null)?.isSuperAdmin === true;

  // The caller's role in their ACTIVE org (not the global user role) decides who can
  // manage that org's keys. Reuses the sidebar's org query, so no extra fetch.
  const { data: organizations } = useQuery({ ...navOrganizationsQuery, enabled: isAuthenticated });
  const activeRole = organizations?.find((o) => o.id === activeOrgId)?.currentUserRole ?? null;
  const canManage = isSuperAdmin || roleCanManageOrg(activeRole);

  return (
    <ApiKeysPageContainer
      route={Route}
      canManage={canManage}
      breadcrumbs={[{ label: "Home", href: "/" }, { label: "API Keys" }]}
    />
  );
}
